module.exports = __webpack_public_path__ + "static/media/yourtable.09e85b0f.mp4";